export default function (el) {
	const rect = el.getBoundingClientRect()
	const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {
		left: rect.left + scrollLeft,
		top: rect.top + scrollTop
	}
}
